module.exports = "type Person {\n  firstname: string\n  lastname: string\n}\n\nvar p = new Person"